import * as React from 'react'
import PageHeader from "../../components/Header/PageHeader";
import MediaQuery from "react-responsive";
import {RequestsLink} from "../registry/RegistryRequestsController";
import {useKeycloak} from "@nic-react/auth";
import {useQuery} from "@tanstack/react-query";
import {setUrlToHTTPs} from "../../utils";
import {useAppendAuthorizationHeader} from "../../utils/connector/api-connector";
import Spinner from "../../components/Spinner/Spinner";
import * as Types from "../../types/ResponseTypes";
import {ReactNode} from "react";
import Request from "../../model/Request";
import {fillRequest} from "../../components/Common";
import RequestViewController from "../registry/RequestViewController";
import {AppConf} from "../../AppConf";

interface RegistrarRequestsControllerI {}
const RegistrarRequestsController: React.FC<RegistrarRequestsControllerI> = (props) => {
    const [expand, setExpand] = React.useState(false)
    const {keycloak} = useKeycloak()
    const {tokenParsed} = keycloak
    const header = useAppendAuthorizationHeader()
    const requestsData = useQuery({
        queryKey: ['requests', 'registrar',  `${tokenParsed.registrar}`],
        queryFn: async () => {
            const {url:rootAPI} = AppConf.getRootUrl(keycloak.realm ? keycloak.realm : '');
            const data =
                await fetch(setUrlToHTTPs(`${rootAPI}/requests`), {...header})
            return data.json()
        }}
    )

    if (requestsData.isFetched) {
      //  console.log('REquestData. ', requestsData.data)
        const requests = requestsData.data
        const requestElements = (requests._embedded ? requests._embedded.requests : null);
        const extraInfo: Types.ResponseType.Page =  requests.page ?? {size: 0, totalElements: 0, totalPages: 0, number: 0};
        const extraLink: Types.ResponseType.ResponseLinks = requests._links ?? {first: null, last: null, self: null};


        const requestsList = new Array<ReactNode>();
        if (requestElements) {
        //    console.log('RequestElements: ', requestElements)
            requestElements.forEach((requestItem: any, i: number) => {
            //    console.log('Request: ', requestItem);
                let reqObj = new Request();
                fillRequest(reqObj, requestItem);
                requestsList.push(
                    <RequestViewController
                        key={i}
                        request={reqObj}

                    />
                )
            })
            return (

                <PageHeader
                    breadcrumb={[{label: 'Home', pathname: '/home'}, {label: 'requests', pathname: '/requests'}]}>
                    <MediaQuery component={'div'} minWidth={1135}>
                        <RequestsLink pageInfo={extraInfo} links={extraLink} expand={expand}
                                      handleExpand={(e: boolean) => {
                                          setExpand(e)
                                      }} direction={'row'}/>
                    </MediaQuery>

                    <MediaQuery component={'div'} minWidth={300} maxWidth={1134}>
                        <RequestsLink pageInfo={extraInfo} links={extraLink} expand={expand}
                                      handleExpand={(e: boolean) => {
                                          setExpand(e)
                                      }} direction={'column'}/>
                    </MediaQuery>

                    <div
                        style={{
                            marginTop: '5px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between'
                        }}
                    >
                        {requestsList}
                    </div>
                </PageHeader>
            )

        }
    }

    if (requestsData.isError) {
        return <span>Error</span>
    }

    return <Spinner/>
}

export default RegistrarRequestsController